import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';
import { ReactComponent as Svg } from 'assets/teams-refresh.svg';
import './icons.scss';

const TeamsRefreshIcon = (props: SvgIconProps) => {
  const {
    color,
    fontSize,
    htmlColor,
    shapeRendering,
    sx,
    titleAccess,
    viewBox,
  } = props;

  return (
    <SvgIcon
      color={color}
      fontSize={fontSize}
      htmlColor={htmlColor}
      shapeRendering={shapeRendering}
      sx={{ ...sx }}
      className='icons'
      titleAccess={titleAccess}
      viewBox={viewBox ?? '-6 -6 32 32'}
      component={Svg}
    />
  );
};

export default TeamsRefreshIcon;
